export default "__VITE_ASSET__82MFsijK__"